import React from 'react'
import SocialMediaCardStyle from './Style'
import { ISocialMediaCard } from './Types'

export default function SocialMediaCard(props: ISocialMediaCard): JSX.Element {
  return (
    <>
      <SocialMediaCardStyle.ButtonStyle onClick={props.onClick}>
        <SocialMediaCardStyle.CardStyle>
          <SocialMediaCardStyle.CardContentStyle>
            <props.icon />
            <SocialMediaCardStyle.CardTitle>
              {props.platformName}
            </SocialMediaCardStyle.CardTitle>
            <SocialMediaCardStyle.CardSubtitle>
              {props.description}
            </SocialMediaCardStyle.CardSubtitle>
          </SocialMediaCardStyle.CardContentStyle>
        </SocialMediaCardStyle.CardStyle>
      </SocialMediaCardStyle.ButtonStyle>
    </>
  )
}
